import type { FunctionalComponent, HTMLAttributes } from 'vue'

export const TransferIcon: FunctionalComponent<HTMLAttributes> = (props) => {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 3h3v18.5l-7-7h4V3zM16.5 21h-3V2.5l7 7h-4V21z" fill="var(--colors-bg-icon-secondary)"></path>
    </svg>
  )
}
